export default __webpack_public_path__ + "static/media/christmas-battle-pass.8cfe003c.png";